// ./Candidate/CandidateSlice/Interview/InterviewAPI.js
import { fetchToken } from "../../../../../common/FetchCookie";
import {
  BASE_URL,
  EMPLOYER,
  EMPLOYER_APPLICANT_INTERVIEW_SCHEDULED,
} from "../../../../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_APPLICANT_INTERVIEW_SCHEDULED}`;

/**
 * Fetch interviews with filters.
 * @param {Object} params
 * @param {'today'|'upcoming'|'past'} [params.type]
 * @param {'awaiting_confirmation'|'scheduled'|'rejected'|'selected'|'hold'} [params.status]
 * @param {number} [params.perPageCount=15]
 * @param {number} [params.page=1]
 */
export const fetchInterviews = async ({
  type,
  status,
  perPageCount = 15,
  page = 1,
} = {}) => {
  const params = new URLSearchParams();

  if (type) params.append("type", type);
  if (status) params.append("status", status);
  if (perPageCount) params.append("perPageCount", perPageCount);
  if (page) params.append("page", page);

  const url = `${API_BASE_URL}?${params.toString()}`;

  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch interviews: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in fetchInterviews:", error);
    throw error;
  }
};

export const addInterview = async (newInterview) => {
  const url = `${API_BASE_URL}`;

  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newInterview),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(
        `Failed to add interview: ${response.status} ${response.statusText} - ${errorBody}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in addInterview:", error);
    throw error;
  }
};

export const updateInterview = async (uuid, data) => {
  const url = `${API_BASE_URL}/${uuid}`;

  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(
        `Error updating interview: ${response.status} ${response.statusText} - ${errorBody}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating interview:", error);
    throw error;
  }
};